import React from "react";
import WayfinderLayout from "./WayfinderLayout";
import { MainLocationTab } from "./MainTabs/MainLocationTab";

const LocationsManagerPage = ({ currentLanguage }) => {
  return <MainLocationTab currentLanguage={currentLanguage} />;
};

// Wrap with layout
const LocationsManagerPageWithLayout = () => (
  <WayfinderLayout>
    <LocationsManagerPage />
  </WayfinderLayout>
);

export default LocationsManagerPageWithLayout;
